import { css } from '@emotion/css';

import { fluidValues, fontStyle } from '@/css/resources/mixins.css';
import {
	breakpoints,
	colors,
	fontFamilies,
	fontWeights,
} from '@/css/resources/variables.css';
import { grid } from '@/css/resources/placeholders.css';
import { cssObj } from '@/css/resources/functions.css';

export const getStyles = () =>
	css(
		fluidValues('paddingTop', 60, 83, true),
		fluidValues('paddingBottom', 62, 104, true),
		{
			'.supt-section__inner': cssObj(grid, {
				rowGap: 20,
			}),
			'.supt-section__headline': {
				gridRow: 1,
				gridColumnStart: '1',
				gridColumnEnd: `span 12`,
				[`@media (min-width: ${breakpoints.medium})`]: {
					gridColumnEnd: `span 9`,
				},
				[`@media (min-width: ${breakpoints.bigLaptop})`]: {
					gridColumnEnd: `span 7`,
				},
			},

			'.supt-section__title': cssObj(
				fontStyle({
					fontFamily: fontFamilies.primary,
					fontWeight: fontWeights.medium,
					fontSize: [66, 110],
					lineHeight: [54, 94],
					letterSpacing: [0, 0],
					textTransform: 'uppercase',
					color: colors.text,
				})
			),

			'.supt-section__buttons': {
				gridColumn: '1/ span 12',

				[`@media (min-width: ${breakpoints.medium})`]: {
					gridRow: 1,
					gridColumn: '9/ span 4',
					marginTop: 0,
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
				},
				[`@media (min-width: ${breakpoints.bigLaptop})`]: {
					gridColumn: '7/ span 6',
				},

				'.supt-listCards': {
					margin: 0,
				},
			},

			'.supt-section__content': cssObj(fluidValues('marginTop', 40, 50), {
				gridColumn: '1/ span 12',
			}),

			// Don't apply the negative margin-top on next section to avoid overlapping
			'& + .supt-section': {
				marginTop: '0 !important',
			},

			'&.-with-background': {
				'--color-section-background': colors.brand1Base,
				background: 'var(--color-section-background)',
			},
		}
	);

export const getIsLoadingEditStyles = () =>
	css({
		'&::before': {
			content: "''",
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			zIndex: 10,
			display: 'block',
			backgroundColor: 'rgba(255,255,255,.5)',
			pointerEvents: 'none',
			opacity: 0,
			transition: 'opacity 0.2s ease-in-out',
		},

		'.supt-section__content': {
			position: 'relative',
		},

		'&.is-loading': {
			'&::before': {
				opacity: 1,
			},
			'.supt-section__loading': {
				position: 'absolute',
				top: '100px',
				left: '50%',
				zIndex: 11,
				transform: 'translate(-50%,-50%)',
			},
		},
	});
